import { useEffect, useRef, useState } from 'react';
import { useWallDispatch, useWallState } from '../../../../../../../../../stateProviders/WallStateProvider';
import { useFloorPlanDispatch, useFloorPlanState } from '../../../../../../../../../stateProviders/FloorPlanStateProvider';

export const WallDimensionDisplay:React.FC<{}> = ({}) => {

    const wallState = useWallState();
    const wallDispatch = useWallDispatch()
    
    const floorplanDispatch = useFloorPlanDispatch()
    const floorplanState = useFloorPlanState()
    const textRef = useRef<SVGTextElement | null>(null);
    const [textBBox, setTextBbox] = useState<DOMRect | null>(null);
    const [isEditing, setIsEditing] = useState(false);
    const [placeholderInches, setPlaceholderInches] = useState('');
    const inputRef = useRef<HTMLInputElement | null>(null);

    useEffect(() => {
        // Calculate the bounding box of the text after it renders
        if (textRef.current) {
          const bbox = textRef.current.getBBox()
          setTextBbox(bbox);
        }

        if(!placeholderInches)return
        if(floorplanState.pixelToInchRatio)return

        // Calculate the pixels per inch for all walls when the first wall inches is set
        const pixelsPerInch = wallState.lengthInPixels / wallState.lengthInInches
        floorplanDispatch({pixelToInchRatio: pixelsPerInch})

      },[wallState.lengthInInches,floorplanState.walls]);

    // Focus the input when editing
    useEffect( () => {
        if(isEditing && inputRef.current) inputRef.current.focus()
    },[isEditing])

    // Update the placeholderInches for the wall length to match a new inches wall length
    useEffect( () => {
        if(!floorplanState.pixelToInchRatio)return
        setPlaceholderInches(wallState.lengthInInches.toString())
    },[wallState.lengthInInches]) 

    return (<>
        {isEditing 
            ? 
                <foreignObject x={ (((wallState.x1 + wallState.x2) / 2) - 50)} y={ ((wallState.y1 + wallState.y2) / 2) - 15} width="100" height="30">
                    <input
                        ref={inputRef}
                        type="number"
                        value={placeholderInches}
                        onKeyDown={(e) => {if(e.key === 'Enter' || e.key === 'Escape') e.currentTarget.blur()}}
                        onChange={(e) => {
                            setPlaceholderInches(e.target.value)
                        }}
                        onBlur={(e) => {
                            setIsEditing(false)
                            if(!e.target.value || e.target.value === '0'){
                                setPlaceholderInches(wallState.lengthInInches.toString())
                                return
                            }
                            wallDispatch({lengthInInches:parseInt(placeholderInches)})
                            if(!floorplanState.pixelToInchRatio)return
                            //get the new pixel length based on the new typed inches
                            const newPixels = parseInt(placeholderInches) * floorplanState.pixelToInchRatio
                            //determine which axis to update for the wall
                            const axis = wallState.x1 === wallState.x2 ? 'y' : 'x'
                            //loop through corners and update the coordinates for all walls that have the same x or y coordinate
                            const updatedCorners = floorplanState.corners.map((corner) => {
                                const updatedCorner = {...corner}
                                if(axis === 'x'){
                                    if(corner.x === wallState.x2){
                                        if (wallState.x1 < wallState.x2) 
                                            updatedCorner.x = Math.round(wallState.x1 + newPixels)
                                        else
                                            updatedCorner.x = Math.round(wallState.x1 - newPixels)
                                    }
                                }
                                if(axis === 'y'){
                                    if(corner.y === wallState.y2){
                                        if (wallState.y1 < wallState.y2) 
                                            updatedCorner.y = Math.round(wallState.y1 + newPixels)
                                        else 
                                            updatedCorner.y = Math.round(wallState.y1 - newPixels)
                                    }
                                }
                                return updatedCorner
                            });
                            floorplanDispatch({corners:updatedCorners})
                        }}
                        style={{ width: '100%', fontSize: '16px' }}
                    />
                 </foreignObject>
            
            : 
                <>
                    {textBBox && (
                        <rect
                        x={textBBox.x - 5}  // Optional padding of 5
                        y={textBBox.y - 2}
                        width={textBBox.width + 10}  // Optional padding of 10
                        height={textBBox.height + 4}
                        fill="white"
                        />
                    )}
                    <text onClick={() => setIsEditing(true)} ref={textRef} dy='.35em' textAnchor="middle" x={ (wallState.x1 + wallState.x2) / 2} y={(wallState.y1 + wallState.y2) / 2} fill="black">
                        {wallState.lengthInInches
                            ? wallState.lengthInInches + 'in'
                            : '?'
                        }
                    </text>
                    {/* <text textAnchor="start" dy='.35em' x={x -50} y={y-50} fill="red">
                        {floorplanState.walls.length > 0 && floorplanState.walls[wallIndex] + 'px'}
                    </text> */}
                </>
        }
    </>)
}